export default "__VITE_ASSET__pa_ircmB__"